module.exports = __webpack_public_path__ + "static/media/buy-bike.0ed25c56.png";